module.exports = __webpack_public_path__ + "img/ball.8ddf4968.svg";